/* NOTE: This is exporting a Singleton instance of this class (see bottom of the file); */
class ApiSdk {
    #_customHeaderFn = async function () { };
    #_baseBiddingUri;

    /*****************************************************/
    /* START Public Methods */
    /*****************************************************/
    async sendRequest(url, method, body = {}) {
        const customHeaders = await this.#_customHeaderFn({ method, url });
        const response = await fetch(url, {
            method,
            mode: "cors",
            cache: "no-cache",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json",
                ...customHeaders
            },
            redirect: "follow",
            referrerPolicy: "no-referrer",
            body: method === 'GET' ? undefined : JSON.stringify(body)
        });
        if (!response.ok) {
            const err = new Error('Received response status code: ${response.status}');
            err.statusCode = response.status;
            const contentType = response.headers.get('content-type');
            if (contentType && contentType.indexOf('application/json') !== -1) {
                const responseBody = await response.json();
                err.body = responseBody;
            }
            throw err;
        } else {
            const contentType = response.headers.get('content-type');
            const contentLength = response.headers.get('content-length');
            let responseData;
            if (contentType && contentType.indexOf('application/json') !== -1) {
                responseData = await response.json();
            } else if (contentLength > 0) {
                responseData = await response.text();
            }
            return responseData;
        }
    }
    async proposeBid(itemId, badge, amount) {
        const url = `${this.#_baseBiddingUri}/item-raw-bidding/${itemId}/actions/bidder/proposeBid`;
        return await this.sendRequest(url, 'PUT', { badge, amount })
    }
    async proposeBuyNow(itemId, badge, amount) {
        const url = `${this.#_baseBiddingUri}/item-raw-bidding/${itemId}/actions/bidder/proposeBuyNow`;
        return await this.sendRequest(url, 'PUT', { badge, amount })
    }
    async upsertProxyBid(eventId, itemId, badge, amount) {
        const url = `${this.#_baseBiddingUri}/proxyBids/eventId/${eventId}/actions/bidder/upsertProxyBid`;
        return await this.sendRequest(url, 'PUT', { itemId, badge, amount })
    }
    async deleteProxyBid(eventId, itemId, badge) {
        const url = `${this.#_baseBiddingUri}/proxyBids/eventId/${eventId}/actions/bidder/deleteProxyBid`;
        return await this.sendRequest(url, 'PUT', { itemId, badge })
    }
    // The runtime lists proxy bids for the badges named (comma list) — the caller's own badges.
    async getProxyBids(badges = []) {
        const url = `${this.#_baseBiddingUri}/proxyBids?badges=${encodeURIComponent(badges.join(','))}`;
        return await this.sendRequest(url, 'GET');
    }
    async getProxyBidsByEventId(eventId, badges = []) {
        const url = `${this.#_baseBiddingUri}/proxyBids/eventId/${eventId}?badges=${encodeURIComponent(badges.join(','))}`;
        return await this.sendRequest(url, 'GET');
    }
    async getProxyBidsByItemId(itemId, badges = []) {
        const url = `${this.#_baseBiddingUri}/proxyBids/itemId/${itemId}?badges=${encodeURIComponent(badges.join(','))}`;
        return await this.sendRequest(url, 'GET');
    }
    /*****************************************************/
    /* END Public Methods */
    /* START Public Accessors */
    /*****************************************************/
    get customHeaderFn() {
        return this.#_customHeaderFn;
    }
    set customHeaderFn(newCustomHeaderFn) {
        this.#_customHeaderFn = newCustomHeaderFn;
    }
    get baseBiddingUri() {
        return this.#_baseBiddingUri;
    }
    set baseBiddingUri(newBaseBiddingUri) {
        this.#_baseBiddingUri = newBaseBiddingUri;
    }
    /*****************************************************/
    /* END Public Accessors */
    /*****************************************************/
}
//SINGLETON Instance Pattern (ESM modules in browser)
const eventRuntimeApiSdk = new ApiSdk();
export { eventRuntimeApiSdk };